module.exports = __webpack_public_path__ + "static/media/article_revision_32_blue.3e795ed4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/article_revision_32_blue.svg
// module id = 1108
// module chunks = 0